module.exports = "/_next/static/images/marketing-bb11ae13577f7356d88867082c9786e1.svg";